<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{
              $t("society.requests.title")
            }}</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7">
            <v-data-table 
              :headers="headers" 
              :items="socities" 
              :search="search" 
              class="elevation-3"
              sort-by="created_at"
              sort-desc
            >
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  clearable
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  class="col-md-6"
                  @input="sessionStorage(search)"
                ></v-text-field>
              </template>

              <template v-slot:item.type="{ item }">
                {{ item.type ? residentTypes.find((type) => type.id == item.type).name : "" }}
              </template>

              <template v-slot:item.address="{ item }">
                {{
                  `${item.address} , ${item.city}, ${item.state}, ${item.country}`
                }}
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ getFormattedDate(item.created_at) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      :to="
                        '/superadmin/society/requests/' + item.id + '/details'
                      "
                    >
                      <v-icon small> mdi-eye </v-icon>
                    </v-btn>
                  </template>
                  <span>View Details</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="confirmAcceptSocietyRequest(item)"
                    >
                      <v-icon small v-bind="attrs" v-on="on">
                        mdi-check-bold
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Accept</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="confirmRejectSocietyRequest(item)"
                    >
                      <v-icon small v-bind="attrs" v-on="on">
                        mdi-close-thick
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Reject</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog v-model="AcceptDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to Approve? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="acceptSocietyRequest(accept_id)"
            >
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="RejectDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to Reject? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="rejectSocietyRequest(reject_id)"
            >
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("society.requests.headers.type")}`,
          value: "type",
          width: "13%",
        },
        {
          text: `${this.$t("society.requests.headers.name")}`,
          align: "start",
          value: "name",
          width: "20%",
        },
        {
          text: `${this.$t("society.requests.headers.address")}`,
          value: "address",
          width: "25%",
        },
        {
          text: `${this.$t("society.requests.headers.contactPersonName")}`,
          value: "contact_person_name",
          width: "15%",
        },
        {
          text: `${this.$t("society.requests.headers.contactPersonNumber")}`,
          value: "contact_person_number",
          sortable: false,
          width: "12%",
        },
        {
          text: `${this.$t("society.requests.headers.actions")}`,
          value: "actions",
          width: "8%",
          sortable: false,
        },
        {
          text: "Requested On",
          value: "created_at",
          width: "12%",
           sortable: false,
        }
      ],
      socities: [],
      residentTypes: [
        {
          id: 1,
          name: "Residential",
        },
        {
          id: 2,
          name: "Commercial",
        },
         {
          id: 3,
          name: "Residential & Commercial",
        },
      ],
      accept_id: "",
      reject_id: "",
      AcceptDialog: false,
      RejectDialog: false,
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getSocietyRequests() {
      let _self = this;

      _self.$axios.get("superadmin/society/requests").then((response) => {
        let data = response.data;

        if (data.status) {
          _self.socities = data.socities;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    acceptSocietyRequest(society) {
      let _self = this;

      _self.$axios
        .post("superadmin/society/approve/" + society.id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            let index = _self.socities.indexOf(society);
            index != -1 ? _self.socities.splice(index, 1) : "";
            this.closeDialog();
            _self.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    rejectSocietyRequest(society) {
      let _self = this;

      _self.$axios
        .post("superadmin/society/reject/" + society.id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            let index = _self.socities.indexOf(society);
            index != -1 ? _self.socities.splice(index, 1) : "";
            this.closeDialog();
            _self.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    confirmAcceptSocietyRequest(society) {
      (this.AcceptDialog = true), (this.accept_id = society);
    },
    confirmRejectSocietyRequest(society) {
      (this.RejectDialog = true), (this.reject_id = society);
    },
    closeDialog() {
      this.AcceptDialog = false;
      this.RejectDialog = false;
      this.accept_id = "";
      this.reject_id = "";
    },
    getFormattedDate(date) {
      if (!date) return "N/A";
      const moment = require("moment");
      return moment(date).format("DD-MM-YYYY");
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("request_search");
      } else {
        sessionStorage.setItem("request_search", search);
      }
    },
  },
  mounted() {
    this.getSocietyRequests();
    this.search = sessionStorage.getItem("request_search");
  },
};
</script>